import { render, staticRenderFns } from "./RegisterPasskeyResult.vue?vue&type=template&id=2fabc439&scoped=true"
import script from "./RegisterPasskeyResult.vue?vue&type=script&lang=js"
export * from "./RegisterPasskeyResult.vue?vue&type=script&lang=js"
import style0 from "./RegisterPasskeyResult.vue?vue&type=style&index=0&id=2fabc439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabc439",
  null
  
)

export default component.exports